import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store/hooks';
import CustomizedAccordions from '../../atoms/customeAccordian';
import { MuiPopup } from '../../molecules/popupComponent';
import ServiceDetailsCustomerComplaint from './serviceDetails.customerComplaint';
import ServiceDetailsJobDone from './serviceDetails.jobDone';
import ServiceDetailsCard from './serviceDetailsCard';
import { t } from 'i18next';
//Service history details modal 
export default function ServiceDetailsModal(props) {
    var selectedServiceData = props.selectedServiceData;
    var ServiceHistoryDetails = useAppSelector(function (state) { return state.crud; }).ServiceHistoryDetails; // get the all service data from store
    // Define three state for two modal(customer Complaint and job done).
    // const [serviceCustomerComplaintData,setserviceCustomerComplaintData] = useState();
    var _a = useState(), partData = _a[0], setPartData = _a[1];
    var _b = useState(), LabourData = _b[0], setLabourData = _b[1];
    var _c = useState(), serviceCustomerComplaint = _c[0], setServiceCustomerComplaint = _c[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _d = useState('All'), selectedOption = _d[0], setSelectedOption = _d[1];
    var handleOptionSelection = function (option) {
        setSelectedOption(option);
    };
    useEffect(function () {
        FilteredPartData();
        FilteredLabourData();
        FilteredComplaintData();
    }, [ServiceHistoryDetails, selectedServiceData]);
    // Filter and set partData
    var FilteredPartData = function () {
        var _ServiceHistoryDetail;
        if (ServiceHistoryDetails !== null && ServiceHistoryDetails !== void 0 && (_ServiceHistoryDetail = ServiceHistoryDetails.data) !== null && _ServiceHistoryDetail !== void 0 && _ServiceHistoryDetail.JCSpare) {
            var filteredData = ServiceHistoryDetails.data.JCSpare.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.ParentDocID) === (selectedServiceData === null || selectedServiceData === void 0 ? void 0 : selectedServiceData.DocID); });
            var updatedData = filteredData.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                jobType: "Part"
            }); });
            setPartData(updatedData);
        }
    };
    // Filter and set LabourData
    var FilteredLabourData = function () {
        var _ServiceHistoryDetail2;
        if (ServiceHistoryDetails !== null && ServiceHistoryDetails !== void 0 && (_ServiceHistoryDetail2 = ServiceHistoryDetails.data) !== null && _ServiceHistoryDetail2 !== void 0 && _ServiceHistoryDetail2.JCLabour) {
            var filteredLabourData = ServiceHistoryDetails.data.JCLabour.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.ParentDocID) === (selectedServiceData === null || selectedServiceData === void 0 ? void 0 : selectedServiceData.DocID); });
            var updatedData = filteredLabourData.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                jobType: "Labour"
            }); });
            setLabourData(updatedData);
        }
    };
    // Filter & set complaint Data
    var FilteredComplaintData = function () {
        var _ServiceHistoryDetail3;
        if (ServiceHistoryDetails !== null && ServiceHistoryDetails !== void 0 && (_ServiceHistoryDetail3 = ServiceHistoryDetails.data) !== null && _ServiceHistoryDetail3 !== void 0 && _ServiceHistoryDetail3.Complaints) {
            var ComplaintData = ServiceHistoryDetails.data.Complaints.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.ParentDocID) === (selectedServiceData === null || selectedServiceData === void 0 ? void 0 : selectedServiceData.DocID); });
            setServiceCustomerComplaint(ComplaintData);
        }
    };
    // const serviceCustomerComplaint = [
    //   {
    //     dateTime: '21 Sep, 2023, 2:00 pm',
    //     complaint: 'Engine Oil Change...',
    //     imagesList:
    //       [{
    //         images: "https://picsum.photos/seed/picsum/200/300"
    //       }, {
    //         images: "https://picsum.photos/200/300.jpg"
    //       }, {
    //         images: "https://picsum.photos/id/237/200/300"
    //       }, {
    //         images: "https://picsum.photos/seed/picsum/200/300"
    //       }, {
    //         images: "https://picsum.photos/seed/picsum/200/300"
    //       }],
    //     recording: 'https://www2.cs.uic.edu/~i101/SoundFiles/CantinaBand60.wav',
    //     advisorComment: 'Engine oil refilled'
    //   },
    //   {
    //     dateTime: '13 Aug, 2023, 1:00 pm',
    //     complaint: 'Engine Change...',
    //     imagesList:
    //       [{
    //         images: "https://picsum.photos/seed/picsum/200/300"
    //       }, {
    //         images: "https://picsum.photos/200/300.jpg"
    //       }, {
    //         images: "https://picsum.photos/id/237/200/300"
    //       }, {
    //         images: "https://picsum.photos/seed/picsum/200/300"
    //       }, {
    //         images: "https://picsum.photos/seed/picsum/200/300"
    //       }],
    //     recording: 'https://www2.cs.uic.edu/~i101/SoundFiles/CantinaBand60.wav',
    //     advisorComment: 'Engine refilled'
    //   }
    // ]
    // const serviceJobDone = [
    //   {
    //     number: 31151060,
    //     type: 'Part',
    //     name: 'Shoe assembly - brake for spare part',
    //     serviceType: 'Paid Service',
    //     qty: 1
    //   },
    //   {
    //     number: 31151061,
    //     type: 'Labour',
    //     name: 'Paid Service JKB',
    //     serviceType: 'Paid Service',
    //   },
    // ]
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: props.isModalVisible,
        closeIcon: true,
        onClose: function () { return props.onCloseModal(); },
        title: t('Service details'),
        variant: "h1",
        containerStyle: {
            width: lgMode ? '500px' : 'calc(80vw)',
            padding: '0px 16px 16px 16px'
        }
    }, /*#__PURE__*/ React.createElement(ServiceDetailsCard, {
        data: selectedServiceData
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        padding: "5px 0px 5px 0px",
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: '8px',
            marginTop: 2
        }
    }, /*#__PURE__*/ React.createElement(CustomizedAccordions, {
        title: t("Customer complaint history"),
        listLength: 0
    }, /*#__PURE__*/ React.createElement(ServiceDetailsCustomerComplaint, {
        itemList: serviceCustomerComplaint
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        padding: "5px 0px 5px 0px",
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: '8px',
            marginTop: 2
        }
    }, /*#__PURE__*/ React.createElement(CustomizedAccordions, {
        onSelectedOption: handleOptionSelection,
        title: t("Jobs done"),
        listLength: 0,
        dropdown: true
    }, /*#__PURE__*/ React.createElement(ServiceDetailsJobDone, {
        selectedOption: selectedOption,
        filteredPartData: partData,
        filteredLabourData: LabourData
    })))));
}
